import { Injectable, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DescriptionModalComponent } from '../modals/description-modal/description-modal.component';
import { ActivityDescriptionModel } from '@api/api-models/activities/ActivityDescriptionModel';
import { Subscription } from 'rxjs';
import { ActivityTypesService } from '@api/api-services';

@Injectable()
export class DescriptionModelService implements OnDestroy {
  constructor(
    private readonly bsModalService: BsModalService,
    private readonly activityTypeService: ActivityTypesService
  ) {}
  private subscriptions: Subscription[] = [];
  private isModalOpen = false;
  private currentModalRef: BsModalRef | null = null;

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];
    this.isModalOpen = false;
    this.currentModalRef = null;
  }

  public openModal(model: DescriptionModal): void {
    if (this.isModalOpen) {
      return;
    }
    this.isModalOpen = true;

    const initialState = {
      title: model.name,
      descriptionHtml: this.formatHtmlForDisplay(model.descriptionHtml),
      description: model.description ?? ''
    };

    this.currentModalRef = this.bsModalService.show(DescriptionModalComponent, {
      initialState,
      backdrop: 'static'
    });

    if (this.currentModalRef.onHidden) {
      this.currentModalRef.onHidden.subscribe(() => {
        this.isModalOpen = false;
        this.currentModalRef = null;
      });
    }
  }

  private formatHtmlForDisplay(content: string): string {
    return content?.replace(/<p>(.*?)<\/p>/g, (_, text) => `${text}<br>`);
  }

  public showActivityDescription(modal: { id: number; name: string; type: any }): void {
    if (this.isModalOpen) {
      return;
    }
    if (modal.id) {
      const activityDescriptionSubscription = this.activityTypeService
        .getActivityDescription(modal.id, modal.type)
        .subscribe((response: ActivityDescriptionModel) => {
          if (response.ActivityDescription)
            this.openModal({
              name: modal.name,
              description: '',
              descriptionHtml: response.ActivityDescription
            });
        });
      this.subscriptions.push(activityDescriptionSubscription);
    }
  }
}

export class DescriptionModal {
  name: string;
  descriptionHtml: string;
  description?: string;
}
